module.exports = __webpack_public_path__ + "static/media/blue.a2ba7e91.png";